// components/ui/custom-dropdown-menu-trigger.tsx

import { Key } from '@/enums/key';
import { Trigger as PrimitiveTrigger } from '@radix-ui/react-dropdown-menu';
import * as React from 'react';

type CustomTriggerProps = React.ComponentPropsWithoutRef<typeof PrimitiveTrigger>;

export const UI_PRIMITIVE__dropdown_menu_trigger = React.forwardRef<React.ElementRef<typeof PrimitiveTrigger>, CustomTriggerProps>(
  ({ onKeyDown, ...props }, ref) => {
    /*
     * EVENTS
     */

    function onKeyDownInternal(event: React.KeyboardEvent<HTMLButtonElement>) {
      if (event.key === Key.Enter) {
        event.preventDefault();
        event.stopPropagation();
      }

      // Call user's own onKeyDown if they provided one
      onKeyDown?.(event);
    }

    /*
     * HTML
     */

    return <PrimitiveTrigger ref={ref} onKeyDown={onKeyDownInternal} {...props} />;
  },
);

UI_PRIMITIVE__dropdown_menu_trigger.displayName = 'DropdownMenuTrigger';
